<style lang="scss" rel="stylesheet/scss" scoped>
#canvas {
  position: fixed;
}
.viewer-wrapper {
  background: #333;
  height: auto;
}
.methods {
  margin-bottom: 1em;
  flex-wrap: wrap;
  & > * {
    margin-right: 0.75rem;
  }
}
.options-panel {
  .panel-block {
    padding: 0;
    .checkbox {
      display: block;
      width: 100%;
      margin: 0;
      padding: 0.5em 0.75em;
    }
  }
}
.viewer {
  height: 100%;
  .images {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px;
    .image-wrapper {
      display: inline-block;
      width: calc(33% - 20px);
      margin: 5px 5px 0 5px;
      .image {
        width: 100%;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}
</style>
<template>
    <div>
      <v-btn v-on:click="activateCopy()" v-if="!copiable" color="success" small style="display:block; margin-left: auto; top: 0px; color: #fff;z-index: 10;">Enable Copy</v-btn>
      <v-btn v-on:click="disableCopy()" v-if="copiable" small  color="grey" style="display:block; margin-left: auto; top: 0px; z-index: 10;">Disable Copy</v-btn>
      <div class="viewer-wrapper" ref="viewerContainer" style="">
        <div :options="options" class="viewer" ref="viewer" >
          <img :src="documentImage" @load="startViewer" :key="documentImage" width="100%" ref="viewerImage" />
        </div>
      </div>
      <canvas v-show="copiable" ref="canvas" id="canvas" width="850" height="800" style="left: 0; top: 0; z-index: 8; border: 0px solid red; -webkit-transform:translate3d(0px, 0px); transform:translate3d(0px, 0px);">
      </canvas>
    </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';


// let canvas = null;
// let canvasContainer = null;
// let ctx = null;
// let rect = {startX: 0, startY: 0, w: 0, h: 0};
// let drag = false;
// let viewer = null;


export default {
  name: 'copiable-image',
  props: ['documentImage', 'onSelect', 'angle'],
  data() {
    return {
      timeout: null,
      copiable: false,
      canvas: null,
      canvasContainer: null,
      ctx: null,
      rect: {startX: 0, startY: 0, w: 0, h: 0},
      drag: false,
      viewer: null,
      options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": false, "keyboard": false }
    }
  },
  components: {
  },
  methods: {
    disableCopy: function() {
      this.copiable = false;
    },
    activateCopy: function() {
      this.copiable = true;
      // this.canvas =  this.$refs.canvas;
      // this.canvasContainer =  this.$refs.canvasContainer;
      // this.ctx = this.canvas.getContext('2d');
      this.scaleCanvas();

    },
    scaleCanvas: function() {

      //this.viewer = this.viewer;
      // onSelect = this.onSelect;
      let viewerElement = this.$refs.viewer;
      if(!this.viewer) {
        console.log("viewer not found");
        return null;
      }

      if(!this.$refs.canvas) {
        console.log("no canvas");
        return false;
      }


      // this.canvas =  this.$refs.canvas;
      // this.canvasContainer =  this.$refs.canvasContainer;
      this.ctx = this.canvas.getContext('2d');


      let canvas =  this.$refs.canvas;
      //
      // canvasContainer =  this.$refs.canvasContainer;
      // ctx = canvas.getContext('2d');

      this.rect = {startX: 0, startY: 0, w: 0, h: 0};
      // drag = false;

      let img = this.viewer.image;
      let prop = this.getProperties(img);
      let viewerProp = this.getProperties(viewerElement);

      console.log("viewer", this.viewer);
      console.log("viewerElement", viewerElement);
      console.log("img", img);


      // prop.naturalHeight = img.naturalHeight;
      // prop.naturalWidth = img.naturalWidth;
      prop.marginLeft = img.offsetLeft;
      prop.marginTop = img.offsetTop;
      prop.clientWidth = img.clientWidth;
      prop.clientHeight = img.clientHeight;

      canvas.width = prop.clientWidth;
      canvas.height = prop.clientHeight;
      //canvasContainer.style.width = prop.clientWidth + "px";
      //canvasContainer.style.height = prop.clientHeight + "px";
      //canvasContainer.style.marginTop = prop.clientHeight + "px";
      canvas.style.position = "fixed";
     //canvas.style.top = img.y + window.scrollY + "px";
     canvas.style.top = img.y + "px";
     canvas.style.left = img.x + "px";

     // canvas.style.transform = "translate3d(" + canvas.style.left + "px," + canvas.style.top + "px)";
     // canvas.style.webkitTransform = "translate3d(" + canvas.style.left + "px," + canvas.style.top + ")";


     console.log("img.getBoundingClientRect().top", img.getBoundingClientRect().top);
     // console.log("window.scrollY", window.scrollY);
     // console.log("window.pageYOffset", window.pageYOffset);


      // canvas.x = img.x;
      // canvas.y = img.y;

      // console.log("viewerProp", viewerProp);
      // console.log("viewer", viewer);
      console.log("prop", prop);
      // console.log("canvas.style", canvas.style);

    },
    startViewer: function() {
      if(this.viewer) {
        this.viewer.destroy();
      }

      let that = this;

      //onSelect = this.onSelect;
      let viewerElement = this.$refs.viewer;
      this.canvas = this.$refs.canvas;
      this.canvasContainer =  this.$refs.canvasContainer;
      this.ctx = this.canvas.getContext('2d');
      this.rect = {startX: 0, startY: 0, w: 0, h: 0};

      viewerElement.addEventListener('zoomed', function () {
          that.scaleCanvas();
      });

      this.init();
      //resizeCanvas();



      this.options.viewed = function() {
        console.log("angle", that.angle);
        if(that.angle) {
          console.log("rotate", -that.angle);
          this.viewer.rotate(-that.angle);
        }
        // that.activateCopy();.o
        // that.disableCopy();
        // that.activateCopy();
      }



      this.viewer = new Viewer(this.$refs.viewer, this.options);
      // this.viewer = viewer;

      // let viewerImage = this.viewer.image;

      // console.log("this.$refs.viewer", this.$refs.viewer);
      // console.log("viewer", viewer);


    },
    init: function() {
      // console.log("ctx");
      if(this.canvas) {
        this.canvas.addEventListener('mousedown', this.mouseDown, false);
        this.canvas.addEventListener('mouseup', this.mouseUp, false);
        this.canvas.addEventListener('mousemove', this.mouseMove, false);
      }

    },
    mouseDown: function(e) {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;


      this.rect.startX = e.pageX - canvas.offsetLeft;
      this.rect.startY = (e.pageY - canvas.offsetTop)-window.scrollY;

      console.log("this.rect", this.rect);
      console.log("e.pageX", e.pageX);
      console.log("e.offsetLeft", e.offsetLeft);
      console.log("canvas.offsetLeft", canvas.offsetLeft);

      this.ctx.clearRect(0,0,canvas.width,canvas.height);
      this.drag = true;
    },
    mouseUp: function() {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      this.drag = false;
      let imageProperties = this.getImageProperties();
      imageProperties.selection = {...rect};
      let scaled = this.scaleProperties(imageProperties);
      // ctx.clearRect(0,0,canvas.width,canvas.height);
      // console.log("imageProperties", imageProperties);
      // console.log("scaled", scaled);
      try {
        this.onSelect(scaled);
      } catch(err) {
        console.log("onSelectError", err);
      }


      rect.w = 0;
      rect.h = 0;
    },
    scaleProperties: function(prop) {
      let result = {};
      result.x = (prop.selection.startX*prop.naturalWidth)/prop.clientWidth;
      result.w = (prop.selection.w*prop.naturalWidth)/prop.clientWidth;
      result.y = (prop.selection.startY*prop.naturalHeight)/prop.clientHeight;
      result.h = (prop.selection.h*prop.naturalHeight)/prop.clientHeight;
      return result;
    },
    offset: function(el) {
      var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    },
    getProperties: function(el) {
      let prop = this.offset(el);

      // prop.naturalHeight = el.naturalHeight;
      // prop.naturalWidth = el.naturalWidth;
      prop.marginLeft = el.offsetLeft;
      prop.marginTop = el.offsetTop;
      prop.clientWidth = el.clientWidth;
      prop.clientHeight = el.clientHeight;
      return prop;
    },
    getImageProperties: function() {
      let img = this.viewer.image;
      let prop = this.getProperties(img);
      prop.naturalHeight = img.naturalHeight;
      prop.naturalWidth = img.naturalWidth;
      prop.marginLeft = img.offsetLeft;
      prop.marginTop = img.offsetTop;
      prop.clientWidth = img.clientWidth;
      prop.clientHeight = img.clientHeight;
      return prop;
    },
    mouseMove: function(e) {

      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      if (this.drag) {
        console.log("dragging");
        this.rect.w = (e.pageX - canvas.offsetLeft) - rect.startX;
        this.rect.h = ((e.pageY - canvas.offsetTop) - rect.startY)-window.scrollY ;
        ctx.clearRect(0,0,canvas.width,canvas.height);
        this.draw();
      }
    },
    draw: function() {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      ctx.setLineDash([6]);
      ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
    }
  },
  beforeMount() {

  },
  mounted: function() {

    // let canvas = null;
    // let canvasContainer = null;
    // let ctx = null;
    // let rect = {startX: 0, startY: 0, w: 0, h: 0};
    // let drag = false;
    // let viewer = null;
    //
    // let onSelect = function(scaled) {
    //
    // }



    // function mouseDown(e) {
    //   rect.startX = e.pageX - this.offsetLeft;
    //   rect.startY = (e.pageY - this.offsetTop)-window.scrollY;
    //   ctx.clearRect(0,0,canvas.width,canvas.height);
    //   drag = true;
    // }

    // function mouseUp() {
    //   drag = false;
    //   let imageProperties = getImageProperties();
    //   imageProperties.selection = {...rect};
    //   let scaled = scaleProperties(imageProperties);
    //   // ctx.clearRect(0,0,canvas.width,canvas.height);
    //   // console.log("imageProperties", imageProperties);
    //   // console.log("scaled", scaled);
    //   try {
    //     onSelect(scaled);
    //   } catch(err) {
    //     console.log("onSelectError", err);
    //   }
    //
    //
    //   rect.w = 0;
    //   rect.h = 0;
    // }
    // function mouseMove(e) {
    //
    //   if (drag) {
    //     console.log("dragging");
    //     rect.w = (e.pageX - this.offsetLeft) - rect.startX;
    //     rect.h = ((e.pageY - this.offsetTop) - rect.startY)-window.scrollY ;
    //     ctx.clearRect(0,0,canvas.width,canvas.height);
    //     draw();
    //   }
    // }

    // function draw() {
    //   //console.log("ctx", ctx);
    //   //console.log("draw", rect);
    //   ctx.setLineDash([6]);
    //   ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
    // }


    // function offset(el) {
    //   var rect = el.getBoundingClientRect(),
    //   scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    //   scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    // }



    // function absolutePosition(el) {
    //     var found,
    //         left = 0,
    //         top = 0,
    //         width = 0,
    //         height = 0,
    //         offsetBase = absolutePosition.offsetBase;
    //     if (!offsetBase && document.body) {
    //         offsetBase = absolutePosition.offsetBase = document.createElement('div');
    //         offsetBase.style.cssText = 'position:absolute;left:0;top:0';
    //         document.body.appendChild(offsetBase);
    //     }
    //     if (el && el.ownerDocument === document && 'getBoundingClientRect' in el && offsetBase) {
    //         var boundingRect = el.getBoundingClientRect();
    //         var baseRect = offsetBase.getBoundingClientRect();
    //         found = true;
    //         left = boundingRect.left - baseRect.left;
    //         top = boundingRect.top - baseRect.top;
    //         width = boundingRect.right - boundingRect.left;
    //         height = boundingRect.bottom - boundingRect.top;
    //     }
    //     return {
    //         found: found,
    //         left: left,
    //         top: top,
    //         width: width,
    //         height: height,
    //         right: left + width,
    //         bottom: top + height
    //     };
    // }

    // function resizeCanvas() {
    //   // canvas.width = window.innerWidth;
    //   // canvas.height = window.innerHeight;
    //   //console.log("window.innerWidth", window.innerWidth);
    //
    //   /**
    //   * Your drawings need to be inside this function otherwise they will be reset when
    //   * you resize the browser window and the canvas goes will be cleared.
    //   */
    //   //drawStuff();
    // }


    // function getProperties(el) {
    //   let prop = offset(el);
    //
    //   // prop.naturalHeight = el.naturalHeight;
    //   // prop.naturalWidth = el.naturalWidth;
    //   prop.marginLeft = el.offsetLeft;
    //   prop.marginTop = el.offsetTop;
    //   prop.clientWidth = el.clientWidth;
    //   prop.clientHeight = el.clientHeight;
    //   return prop;
    // }

    // function scaleProperties(prop) {
    //   let result = {};
    //   result.x = (prop.selection.startX*prop.naturalWidth)/prop.clientWidth;
    //   result.w = (prop.selection.w*prop.naturalWidth)/prop.clientWidth;
    //   result.y = (prop.selection.startY*prop.naturalHeight)/prop.clientHeight;
    //   result.h = (prop.selection.h*prop.naturalHeight)/prop.clientHeight;
    //   return result;
    // }

    // function getImageProperties() {
    //   let img = viewer.image;
    //   let prop = getProperties(img);
    //   prop.naturalHeight = img.naturalHeight;
    //   prop.naturalWidth = img.naturalWidth;
    //   prop.marginLeft = img.offsetLeft;
    //   prop.marginTop = img.offsetTop;
    //   prop.clientWidth = img.clientWidth;
    //   prop.clientHeight = img.clientHeight;
    //   return prop;
    // }


    // this.canvas =  this.$refs.canvas;
    //
    // this.canvasContainer =  this.$refs.canvasContainer;
    // this.ctx = canvas.getContext('2d');

    // onSelect = this.onSelect;
    this.scaleCanvasTimeout = null;
    let that = this;

    // this.startViewer();
    console.log("startViewer");

    //this.activateCopy();
    // this.activateCopy();
    //this.timeout = setTimeout(this.activateCopy, 5000);

    let scaleCanvas = function() {
      if(that.scaleCanvasTimeout) {
        clearTimeout(that.scaleCanvasTimeout);
      }

      that.scaleCanvasTimeout = setTimeout(that.scaleCanvas, 300);
    }



    window.addEventListener("resize", scaleCanvas);
    window.addEventListener("scroll", scaleCanvas);



    // window.addEventListener('resize', this.scaleCanvas, false);

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.scaleCanvas);
    window.removeEventListener("scroll", this.scaleCanvas);

    if(this.scaleCanvasTimeout) {
      clearTimeout(this.scaleCanvasTimeout);
    }
    if(this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
</script>
